module.exports = __webpack_public_path__ + "static/media/dem_she_pul.123b5788.png";